export interface InstallmentRow {
  months: number;
  monthly: number;
  total: number;
  interestFree: boolean;
}

const TERMS = [3, 6, 9, 12] as const;

/**
 * Ürün fiyatı ve admin oranlarından taksit satırları üretir.
 * config: product_info.installment_{n}_rate -> yüzde komisyon (string).
 * Boş/geçersiz oranlı vadeler atlanır. Tek çekim (1 ay) her zaman eklenir.
 */
export function buildInstallmentRows(
  price: number,
  config: Record<string, string | undefined>,
): InstallmentRow[] {
  const rows: InstallmentRow[] = [
    { months: 1, monthly: price, total: price, interestFree: true },
  ];

  for (const months of TERMS) {
    const raw = config[`product_info.installment_${months}_rate`];
    if (raw == null || raw.trim() === "") continue;
    const rate = Number(raw);
    if (!Number.isFinite(rate) || rate < 0) continue;

    const total = price * (1 + rate / 100);
    rows.push({
      months,
      total,
      monthly: total / months,
      interestFree: rate === 0,
    });
  }

  return rows;
}
